import { useEffect, useRef, useState } from "react";
import { ToastTypes } from "../contexts/toastr.context";
import { history } from "../_config";
import { OrganizationService } from "../_service/organization.service";
import { ActionModal } from "./action-modal.component";
import { Button } from "./button.component";
import Switch from "./switch.component";
import { TextInput } from "./text-input.component";
import continents from "../_config/country-codes.config.json";
import Timezones from "../_config/timezones.config.json";
import trashIcon from "../_assets/images/trash.png";
import uploadIcon from "../_assets/images/upload.png";
import galleryIcon from "../_assets/images/gallery.png";
import { setOrganization } from "../_store/_actions/organization.actions";
import { useDispatch } from "react-redux";
import { Loader } from "./loader.component";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";

let timezones = [];
Timezones.map((timezone) => {
  timezone.utc.map((utc) => {
    timezones.push(utc);
  });
});

timezones = timezones.sort();
let fileUploaded = null;

const AccountDetail = ({
  user,
  addToast,
  showEditAccount,
  setShowEditAccount,
  org = {},
}) => {
  const [organizationDetails, setOrganizationDetails] = useState({});
  const [orgName, setOrgName] = useState("");
  const [country, setCountry] = useState("");
  const [website, setWebsite] = useState("");
  const [isOrgActive, setIsOrgActive] = useState(false);
  const [description, setDescription] = useState("");
  const [timezone, setTimezone] = useState("Asia/Kolkata");
  const [isDeleteOrgModalVisible, setIsDeleteOrgModalVisible] = useState(false);
  const hiddenFileInput = useRef(null);
  const [orgImgUrl, setOrgImgUrl] = useState(
    org.organizationLogo ? org.organizationLogo : null
  );
  const [orgImageName, setOrgImageName] = useState("");
  const [orgImg, setOrgImg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [anonymousFeedback, setAnonymousFeedback] = useState(false);
  const [oneOnOne, setOneOnOne] = useState(false);
  const [additionalResourcesTitle, setAdditionalResourcesTitle] = useState("");
  const [additionalResourcesBody, setAdditionalResourcesBody] = useState("");
  const [additionalResourcesURL, setAdditionalResourcesURL] = useState("");

  const [departments, setDepartments] = useState([]);
  const [professions, setProfessions] = useState([]);
  const departmentDefaultOptions = [
    { label: "Not Applicable", value: "notApplicable" },
    { label: "Breast Care", value: "breastCare" },
    { label: "Cancer Care", value: "cancerCare" },
    { label: "Cardiac Care", value: "cardiacCare" },
    { label: "Cardiopulmonary", value: "cardiopulmonary" },
    { label: "Critical Care", value: "criticalCare" },
    { label: "Diagnostic Sleep Center", value: "diagnosticSleepCenter" },
    { label: "Elderly Care", value: "elderlyCare" },
    { label: "Emergency Services", value: "emergencyServices" },
    { label: "ENT & Allergy", value: "eNTAndAllergy" },
    { label: "Hospitalists", value: "hospitalists" },
    { label: "Internal Medicine", value: "internalMedicine" },
    { label: "Medical-Surgical", value: "medicalSurgical" },
    { label: "Neurology and Neurosurgery", value: "NeurologyAndNeurosurgery" },
    {
      label: "Occupational, Physical, and Speech Therapy",
      value: "occupationalPhysicalAndSpeechTherapy",
    },
    { label: "Orthopedics", value: "orthopedics" },
    { label: "Palliative Care", value: "palliativeCare" },
    { label: "Pediatrics", value: "pediatrics" },
    { label: "Primary Care", value: "primaryCare" },
    { label: "Radiology", value: "radiology" },
    { label: "Rehabilitation", value: "rehabilitation" },
    { label: "Rheumatology", value: "rheumatology" },
    { label: "Stroke Care", value: "strokeCare" },
    { label: "Wound Care", value: "woundCare" },
    { label: "Other", value: "other" },
  ];

  const professionDefaultOptions = [
    { label: "Physicians", value: "physician" },
    { label: "Nurses (non-clinical)", value: "nursesNonClinical" },
    { label: "Nurses (clinical)", value: "nursesClinical" },
    { label: "Allied Health", value: "alliedHealth" },
    { label: "Auxiliary Staff", value: "auxiliary" },
    { label: "Administrative Staff", value: "administrative" },
    { label: "Other", value: "other" },
  ];

  const [defaultMissingDepartments, setDefaultMissingDepartments] = useState(
    []
  );
  const [defaultMissingProfessions, setDefaultMissingProfessions] = useState(
    []
  );

  const dispatch = useDispatch();

  const sp = new URLSearchParams(window.location.search);
  const orgId = sp.get("orgId");

  const isFormSubmitable =
    orgName.length >= 1 &&
    country.length >= 1 &&
    (website.startsWith("http://") || website.startsWith("https://")) &&
    description.length >= 1 &&
    additionalResourcesTitle.trim().length >= 1 &&
    additionalResourcesTitle.length <= 30 &&
    additionalResourcesBody.trim().length >= 1 &&
    additionalResourcesBody.length <= 125 &&
    (additionalResourcesURL.startsWith("http://") ||
      additionalResourcesURL.startsWith("https://")) &&
    departments.length > 0 &&
    professions.length > 0;

  useEffect(() => {
    if (user.role === "orgAdmin") {
      setOrganizationDetails(org);
    }
  }, [user, org]);

  useEffect(() => {
    if (user.role === "superAdmin" && orgId) {
      getOrganizationDetail(orgId);
    }
  }, [user]);

  useEffect(() => {
    setValues();
  }, [organizationDetails]);

  const showEditAccountContent = () => {
    setOrgImageName(null);
    setOrgImg(null);
    setShowEditAccount(!showEditAccount);
    setValues();
    // getOrganizationDetail(orgId);
  };

  const setValues = () => {
    setOrgName(organizationDetails.name ? organizationDetails.name : "");
    setCountry(organizationDetails.country ? organizationDetails.country : "");
    setIsOrgActive(
      organizationDetails.isActive ? organizationDetails.isActive : false
    );
    setDescription(
      organizationDetails.description ? organizationDetails.description : ""
    );
    setWebsite(organizationDetails.website ? organizationDetails.website : "");
    setTimezone(
      organizationDetails.timeZone ? organizationDetails.timeZone : ""
    );
    setOrgImgUrl(
      organizationDetails.organizationLogo
        ? organizationDetails.organizationLogo
        : ""
    );
    setAnonymousFeedback(
      organizationDetails.anonymousFeedback
        ? organizationDetails.anonymousFeedback
        : false
    );
    setOneOnOne(
      organizationDetails.oneOnOne ? organizationDetails.oneOnOne : false
    );
    setAdditionalResourcesTitle(
      organizationDetails?.additionalResources?.title
        ? organizationDetails?.additionalResources?.title
        : ""
    );
    setAdditionalResourcesBody(
      organizationDetails?.additionalResources?.body
        ? organizationDetails?.additionalResources?.body
        : ""
    );
    setAdditionalResourcesURL(
      organizationDetails?.additionalResources?.url
        ? organizationDetails?.additionalResources?.url
        : ""
    );
    setDepartments(organizationDetails?.departments);
    setProfessions(organizationDetails?.professions);

    if (organizationDetails?.departments) {
      setDefaultDepartments(organizationDetails?.departments);
    }
    if (organizationDetails?.professions) {
      setDefaultProfessions(organizationDetails?.professions);
    }
  };

  const setDefaultProfessions = (prf) => {
    const missingProfessions = professionDefaultOptions.filter(
      (defaultItem) => {
        return !prf.some((pf) => pf.value == defaultItem.value);
      }
    );
    setDefaultMissingProfessions([...missingProfessions]);
  };

  const setDefaultDepartments = (depts) => {
    const missingDepartments = departmentDefaultOptions.filter(
      (defaultItem) => {
        return !depts.some((newItem) => newItem.value == defaultItem.value);
      }
    );
    setDefaultMissingDepartments([...missingDepartments]);
  };

  const getOrganizationDetail = (orgId) => {
    OrganizationService.getOrganizationDetail(user, orgId)
      .then((resp) => {
        setOrganizationDetails(resp);
      })
      .catch((error) => {
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const submitOrgDetails = () => {
    if (orgImageName) {
      uploadOrgImage(orgImg);
    } else {
      editOrganization(orgImgUrl);
    }
  };

  const showDeleteModal = () => {
    setIsDeleteOrgModalVisible(true);
  };

  const onSubmitDeleteOrg = () => {
    OrganizationService.deleteOrganization(user, orgId)
      .then((resp) => {
        setIsDeleteOrgModalVisible(false);
        history.push("/organizations");
        addToast("Organization deleted successfully", "", ToastTypes.success);
      })
      .catch((error) => {
        setIsDeleteOrgModalVisible(false);
        addToast("Unable to delete the organization", "", ToastTypes.danger);
      });
  };

  const handleChange = (event) => {
    fileUploaded = event.target.files[0];
    setOrgImageName(fileUploaded.name);
    setOrgImg(URL.createObjectURL(fileUploaded));
  };

  const uploadOrgImage = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", fileUploaded, fileUploaded.name);
    await OrganizationService.uploadImage(user, formData)
      .then((resp) => {
        const orgData = organizationDetails;
        orgData.organizationLogo = resp.url;
        setOrganizationDetails(orgData);
        setOrgImgUrl(resp.url);
        editOrganization(resp.url);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const editOrganization = (imgUrl) => {
    const orgData = {
      name: orgName,
      country: country,
      website: website,
      isActive: isOrgActive,
      description: description,
      organizationLogo: imgUrl,
      timeZone: timezone,
      oneOnOne: oneOnOne,
      anonymousFeedback: anonymousFeedback,
      additionalResources: {
        title: additionalResourcesTitle,
        body: additionalResourcesBody,
        url: additionalResourcesURL,
      },
      departments,
      professions,
    };
    OrganizationService.updateOrganization(user, orgId, orgData)
      .then((resp) => {
        setIsLoading(false);
        setOrganizationDetails(resp);
        dispatch(setOrganization({ organization: resp }));
        setShowEditAccount(!showEditAccount);
        addToast("Organization edited successfully", "", ToastTypes.success);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleDelete = (event) => {
    // const orgData = organizationDetails;
    // orgData.organizationLogo = null;
    // setOrganizationDetails(orgData);
    setOrgImgUrl(null);
    setOrgImg(null);
    setOrgImageName("");
    fileUploaded = null;
  };

  if (org && user && Object.keys(org).length <= 0 && user.role === "orgAdmin") {
    return (
      <div className="my-2">
        <Loader />
      </div>
    );
  }

  const handleCreateOptionDepartment = (inputValue) => {
    const optionExists = departments.some(
      (option) => option.label.toLowerCase() === inputValue.toLowerCase()
    );
    if (!optionExists) {
      const newOption = { value: inputValue, label: inputValue };
      setDepartments([...departments, newOption]);
    }
  };

  const handleCreateOptionProfession = (inputValue) => {
    const optionExists = professions.some(
      (option) => option.label.toLowerCase() === inputValue.toLowerCase()
    );
    if (!optionExists) {
      const newOption = { value: inputValue, label: inputValue };
      setProfessions([...professions, newOption]);
    }
  };

  return (
    <div>
      <div className="px-12 py-4">
        <div className="flex items-center justify-between">
          <p className="font-bold text-lg text-primary">Account Details</p>
          {!showEditAccount ? (
            <Button
              label="Edit Profile"
              className="btn-primary px-8"
              onClick={() => showEditAccountContent()}
            />
          ) : (
            <></>
          )}
        </div>
        <div className="flex pt-11">
          <div className="account-image-container border rounded-md">
            {orgImg || orgImgUrl ? (
              <img
                src={
                  orgImg && showEditAccount
                    ? orgImg
                    : organizationDetails.organizationLogo
                }
                alt="account image"
                className="h-full w-full object-contain"
              />
            ) : (
              <div
                className="border flex items-center rounded-md show-img h-full"
                style={{ backgroundColor: !orgImg ? "#F4FAFF" : "" }}>
                <div>
                  <img
                    src={galleryIcon}
                    alt=""
                    className="flex h-10 object-contain text-center w-full"
                  />
                  <div className="text-xs text-center w-9/12 m-auto mt-2 t-grey">
                    Upload an image of the organization's official logo.
                  </div>
                </div>
              </div>
            )}
            {showEditAccount ? (
              <div className="text-xxs mt-2 pb-2 t-grey">
                (Upload file below 20MB)
              </div>
            ) : (
              <></>
            )}
            {showEditAccount ? (
              <div className="flex w-full items-center">
                <input
                  type="file"
                  className="hidden"
                  id="my-file"
                  ref={hiddenFileInput}
                  onChange={handleChange}
                  accept="image/gif, image/jpeg, image/png"
                />
                <div
                  onClick={handleClick}
                  className="border py-1 flex items-center rounded-md overflow-hidden cursor-pointer justify-center w-full px-1">
                  <img src={uploadIcon} alt="" className="h-5 w-5 rounded-md" />
                  <div
                    className={`flex pl-2 t-grey whitespace-nowrap ${
                      orgImageName ? "mr-2 pr-2 border-r" : ""
                    } `}>
                    Choose a file
                  </div>
                  {orgImageName ? (
                    <div className="z-10 w-20 overflow-x-scroll whitespace-nowrap mostly-customized-scrollbar t-grey">
                      {orgImageName}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                {organizationDetails.organizationLogo || orgImg ? (
                  <div
                    className="ml-2 rounded cursor-pointer"
                    onClick={() => handleDelete()}>
                    <img
                      src={trashIcon}
                      alt=""
                      className="h-5 w-5 rounded-md"
                    />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>
          {Object.keys(organizationDetails).length > 0 ? (
            <div className="account-details-container pl-16 w-2/4">
              <div className="flex py-4 border-b items-center justify-between">
                <p
                  className={
                    showEditAccount
                      ? "w-1/2 t-grey font-bold"
                      : "w-3/4 t-grey font-bold"
                  }>
                  Organization Name
                </p>
                {showEditAccount ? (
                  <TextInput
                    key="1"
                    defaultValue={orgName}
                    value={orgName}
                    type="text"
                    validator={(value) => {
                      if (value.length <= 0) {
                        return "Enter valid organization name";
                      }
                    }}
                    placeholder="Enter Organization Name"
                    containerClassName="flex-grow block"
                    className="py-2 items-center t-grey w-1/2"
                    onChange={(value) => {
                      setOrgName(value);
                    }}
                  />
                ) : (
                  <p className="t-grey font-normal w-full ">
                    {organizationDetails.name ? organizationDetails.name : ""}
                  </p>
                )}
              </div>
              <div className="flex py-4 border-b items-center justify-between">
                <p
                  className={
                    showEditAccount
                      ? "w-1/2 t-grey font-bold"
                      : "w-3/4 t-grey font-bold"
                  }>
                  Account Status
                </p>
                <div className="w-full">
                  {showEditAccount ? (
                    <div className="t-grey font-normal w-full flex justify-center">
                      {isOrgActive ? (
                        <div className="text-green-500">Active</div>
                      ) : (
                        <div className="text-red-500">Inactive</div>
                      )}
                      <Switch
                        className="ml-2"
                        toggle={isOrgActive}
                        setToggle={setIsOrgActive}
                      />
                    </div>
                  ) : (
                    <div className="t-grey font-normal w-full">
                      {isOrgActive ? (
                        <div className="text-green-500">Active</div>
                      ) : (
                        <div className="text-red-500">Inactive</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="flex py-4 border-b items-center">
                <div className={showEditAccount ? "w-1/2" : "w-3/4"}>
                  <p
                    className={
                      showEditAccount
                        ? "w-1/2 t-grey font-bold"
                        : "w-3/4 t-grey font-bold"
                    }>
                    Country or Region
                  </p>
                </div>
                {showEditAccount ? (
                  <div className="w-1/2">
                    <select
                      className="border theme-bg-default theme-border-default rounded flex items-center my-3 py-1 px-2 t-grey w-full"
                      value={country}
                      onChange={(e) => {
                        setCountry(e.target.value);
                      }}>
                      {continents.map((item, index) => {
                        return (
                          <option key={index} value={item.country}>
                            {item.country}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                ) : (
                  <div className="w-full">
                    <p className="t-grey font-normal w-full">
                      {organizationDetails.country
                        ? organizationDetails.country
                        : ""}
                    </p>
                  </div>
                )}
              </div>
              <div className="border-b py-4 flex items-center">
                <div
                  style={{
                    width: showEditAccount ? "50%" : "42%",
                    flexShrink: 0,
                  }}>
                  <p
                    className={
                      showEditAccount ? "t-grey font-bold" : "t-grey font-bold"
                    }>
                    Department
                  </p>
                </div>
                <div style={{ width: showEditAccount ? "50%" : "58%" }}>
                  {showEditAccount ? (
                    <CreatableSelect
                      isMulti
                      value={departments}
                      isClearable={false}
                      options={defaultMissingDepartments}
                      createOptionPosition="last"
                      isValidNewOption={(
                        inputValue,
                        selectValue,
                        selectOptions
                      ) => {
                        return inputValue.trim() !== "";
                      }}
                      onCreateOption={handleCreateOptionDepartment}
                      onChange={(item) => {
                        setDepartments([...item]);
                        setDefaultDepartments(item);
                      }}
                      className="w-full"
                      placeholder="Select Department"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          ":hover": {
                            borderColor: "hsl(0, 0%, 80%)",
                            boxShadow: "none",
                          },
                          ":active": {
                            borderColor: "hsl(0, 0%, 80%)",
                            boxShadow: "none",
                          },
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          overflowX: "auto",
                          flexWrap: "unset",
                          ":hover": "unset",
                        }),
                        multiValue: (base) => ({
                          ...base,
                          flex: "0 0 auto",
                        }),
                        multiValueRemove: !showEditAccount
                          ? (base) => ({
                              ...base,
                              display: "none",
                            })
                          : null,
                      }}
                      components={
                        !showEditAccount
                          ? {
                              DropdownIndicator: () => null,
                              IndicatorSeparator: () => null,
                            }
                          : {}
                      }
                    />
                  ) : (
                    <Select
                      isMulti
                      value={departments}
                      isClearable={false}
                      className="w-full"
                      styles={{
                        valueContainer: (base) => ({
                          ...base,
                          overflowX: "auto",
                          flexWrap: "unset",
                        }),
                        multiValue: (base) => ({
                          ...base,
                          flex: "0 0 auto",
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          display: "none",
                        }),
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="border-b py-4 flex items-center">
                <div
                  style={{
                    width: showEditAccount ? "50%" : "42%",
                    flexShrink: 0,
                  }}>
                  <p
                    className={
                      showEditAccount ? "t-grey font-bold" : "t-grey font-bold"
                    }>
                    Profession
                  </p>
                </div>
                <div style={{ width: showEditAccount ? "50%" : "58%" }}>
                  {showEditAccount ? (
                    <CreatableSelect
                      isMulti
                      value={professions}
                      isClearable={false}
                      options={defaultMissingProfessions}
                      createOptionPosition="last"
                      isValidNewOption={(
                        inputValue,
                        selectValue,
                        selectOptions
                      ) => {
                        return inputValue.trim() !== "";
                      }}
                      placeholder="Select Profession"
                      onCreateOption={handleCreateOptionProfession}
                      onChange={(item) => {
                        setProfessions([...item]);
                        setDefaultProfessions(item);
                      }}
                      className="w-full"
                      styles={{
                        valueContainer: (base) => ({
                          ...base,
                          overflowX: "auto",
                          flexWrap: "unset",
                        }),
                        multiValue: (base) => ({
                          ...base,
                          flex: "0 0 auto",
                        }),
                        multiValueRemove: !showEditAccount
                          ? (base) => ({
                              ...base,
                              display: "none",
                            })
                          : null,
                      }}
                      components={
                        !showEditAccount
                          ? {
                              DropdownIndicator: () => null,
                              IndicatorSeparator: () => null,
                            }
                          : {}
                      }
                    />
                  ) : (
                    <Select
                      isMulti
                      value={professions}
                      isClearable={false}
                      className=""
                      styles={{
                        valueContainer: (base) => ({
                          ...base,
                          overflowX: "auto",
                          flexWrap: "unset",
                        }),
                        multiValue: (base) => ({
                          ...base,
                          flex: "0 0 auto",
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          display: "none",
                        }),
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="border-b flex items-center">
                <p
                  className={
                    showEditAccount
                      ? "w-1/2 t-grey font-bold"
                      : "w-3/4 t-grey font-bold"
                  }>
                  Timezone
                </p>
                {showEditAccount ? (
                  <select
                    className="border theme-bg-default theme-border-default rounded flex items-center my-3 py-1 px-2 t-grey w-1/2"
                    value={timezone}
                    onChange={(e) => {
                      setTimezone(e.target.value);
                    }}>
                    {timezones.map((utc, index) => (
                      <option key={utc + index} value={utc}>
                        {utc}
                      </option>
                    ))}
                  </select>
                ) : (
                  <p className="t-grey font-normal w-full my-3 overflow-auto">
                    {organizationDetails.timeZone
                      ? organizationDetails.timeZone
                      : ""}
                  </p>
                )}
              </div>
              <div className="border-b flex pt-2">
                <p
                  className={
                    showEditAccount
                      ? "w-1/2 t-grey font-bold"
                      : "w-3/4 t-grey font-bold"
                  }>
                  Description
                </p>
                {showEditAccount ? (
                  <div className="block w-1/2">
                    <textarea
                      type="text"
                      rows={6}
                      maxLength="250"
                      value={description}
                      placeholder="Enter Description"
                      className="p-2 t-grey border mb-2 items-center w-full mt-2"
                      onChange={(e) => {
                        setDescription(e.target.value);
                      }}
                    />
                    <div className="text-red-500">
                      {description.length <= 0 ? "Enter description" : ""}
                    </div>
                  </div>
                ) : (
                  <p className="t-grey font-normal w-full my-3 overflow-auto h-36">
                    {organizationDetails.description
                      ? organizationDetails.description
                      : ""}
                  </p>
                )}
              </div>
              <div className="border-b flex items-center">
                <p
                  className={
                    showEditAccount
                      ? "w-1/2 t-grey font-bold"
                      : "w-3/4 t-grey font-bold"
                  }>
                  Website
                </p>
                {showEditAccount ? (
                  <TextInput
                    type="text"
                    defaultValue={website}
                    value={website}
                    validator={(value) => {
                      if (
                        value.startsWith("http://") ||
                        value.startsWith("https://") ||
                        value.length === 0
                      ) {
                      } else {
                        return "Invalid website url!";
                      }
                    }}
                    placeholder="https://www.google.com"
                    containerClassName="flex-grow block"
                    className="py-2 t-grey items-center w-1/2"
                    onChange={(value) => {
                      setWebsite(value);
                    }}
                  />
                ) : (
                  <p className="t-grey font-normal w-full my-3 overflow-auto ">
                    {organizationDetails.website
                      ? organizationDetails.website
                      : ""}
                  </p>
                )}
              </div>
              <div className="flex py-4 border-b items-center justify-between">
                <p
                  className={
                    showEditAccount
                      ? "w-1/2 t-grey font-bold"
                      : "w-3/4 t-grey font-bold"
                  }>
                  Anonymous Feedback Visible
                </p>
                <div className="w-full">
                  {showEditAccount ? (
                    <div className="t-grey font-normal w-full flex justify-center">
                      {anonymousFeedback ? (
                        <div className="text-green-500">Active</div>
                      ) : (
                        <div className="text-red-500">Inactive</div>
                      )}
                      <Switch
                        className="ml-2"
                        toggle={anonymousFeedback}
                        setToggle={setAnonymousFeedback}
                      />
                    </div>
                  ) : (
                    <div className="t-grey font-normal w-full">
                      {anonymousFeedback ? (
                        <div className="text-green-500">Active</div>
                      ) : (
                        <div className="text-red-500">Inactive</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="flex py-4 border-b items-center justify-between">
                <p
                  className={
                    showEditAccount
                      ? "w-1/2 t-grey font-bold"
                      : "w-3/4 t-grey font-bold"
                  }>
                  One on One Visible
                </p>
                <div className="w-full">
                  {showEditAccount ? (
                    <div className="t-grey font-normal w-full flex justify-center">
                      {oneOnOne ? (
                        <div className="text-green-500">Active</div>
                      ) : (
                        <div className="text-red-500">Inactive</div>
                      )}
                      <Switch
                        className="ml-2"
                        toggle={oneOnOne}
                        setToggle={setOneOnOne}
                      />
                    </div>
                  ) : (
                    <div className="t-grey font-normal w-full">
                      {oneOnOne ? (
                        <div className="text-green-500">Active</div>
                      ) : (
                        <div className="text-red-500">Inactive</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="flex py-4 border-b items-center justify-between">
                <p
                  className={
                    showEditAccount
                      ? "w-1/2 t-grey font-bold"
                      : "w-3/4 t-grey font-bold"
                  }>
                  Additional Resource Title
                </p>
                {/* <div className="w-1/2"> */}
                {showEditAccount ? (
                  <TextInput
                    key="1"
                    defaultValue={additionalResourcesTitle}
                    value={additionalResourcesTitle}
                    type="text"
                    validator={(value) => {
                      if (value.trim().length <= 0) {
                        return "Enter valid additional resource title";
                      }
                      if (value.length > 30) {
                        return "Additional resource title length should be less than 30 characters";
                      }
                    }}
                    placeholder="Enter additional resource title"
                    containerClassName="flex-1 block"
                    className="py-2 items-center t-grey w-1/2"
                    onChange={(value) => {
                      setAdditionalResourcesTitle(value);
                    }}
                  />
                ) : (
                  <p className="t-grey font-normal w-full my-3 overflow-auto ">
                    {organizationDetails?.additionalResources?.title
                      ? organizationDetails?.additionalResources?.title
                      : ""}
                  </p>
                )}
                {/* </div> */}
              </div>
              <div className="flex py-4 border-b items-center justify-between">
                <p
                  className={
                    showEditAccount
                      ? "w-1/2 t-grey font-bold"
                      : "w-3/4 t-grey font-bold"
                  }>
                  Additional Resource URL
                </p>
                {/* <div className="w-1/2"> */}
                {showEditAccount ? (
                  <TextInput
                    key="1"
                    defaultValue={additionalResourcesURL}
                    value={additionalResourcesURL}
                    type="text"
                    validator={(value) => {
                      if (
                        !(
                          value.startsWith("http://") ||
                          value.startsWith("https://")
                        )
                      ) {
                        return "Invalid additional resource url!";
                      }
                      if (value.length <= 0) {
                        return "Invalid additional resource url!";
                      }
                    }}
                    placeholder="Enter additional resource url"
                    containerClassName="flex-1 block"
                    className="py-2 items-center t-grey w-1/2"
                    onChange={(value) => {
                      setAdditionalResourcesURL(value);
                    }}
                  />
                ) : (
                  <p className="t-grey font-normal w-full my-3 overflow-auto ">
                    {organizationDetails?.additionalResources?.url
                      ? organizationDetails?.additionalResources?.url
                      : ""}
                  </p>
                )}
                {/* </div> */}
              </div>
              <div className="flex py-4 border-b justify-between">
                <p
                  className={
                    showEditAccount
                      ? "w-1/2 t-grey font-bold"
                      : "w-3/4 t-grey font-bold"
                  }>
                  Additional Resource Body
                </p>
                {showEditAccount ? (
                  <div className="block w-1/2">
                    <textarea
                      type="text"
                      rows={4}
                      maxLength="125"
                      value={additionalResourcesBody}
                      placeholder="Enter additional resource body"
                      className="p-2 t-grey border mb-2 items-center w-full"
                      onChange={(e) => {
                        setAdditionalResourcesBody(e.target.value);
                      }}
                    />
                    <div className="text-red-500">
                      {additionalResourcesBody.trim().length <= 0
                        ? "Enter valid additional resource body"
                        : ""}
                    </div>
                  </div>
                ) : (
                  <p className="t-grey font-normal w-full my-3 overflow-auto h-36">
                    {organizationDetails?.additionalResources?.body
                      ? organizationDetails?.additionalResources?.body
                      : ""}
                  </p>
                )}
                {/* </div> */}
              </div>
            </div>
          ) : (
            <div className="account-details-container pl-16 w-2/4">
              <Button isLoading="true"></Button>
            </div>
          )}
        </div>
      </div>
      {!showEditAccount ? (
        <div className="px-12 py-4 hidden">
          <div className="flex items-center justify-between">
            <p className="font-bold text-lg text-primary">Subscription Plan</p>
            <Button
              label="Edit Plan"
              className="btn-primary px-8 cursor-not-allowed"
            />
          </div>
          <div className="flex pt-11">
            <div className="account-details-container w-2/4">
              <div className="flex py-4 border-b items-center">
                <p className="w-2/3 t-grey font-bold">Plan Type</p>
                <p className="t-grey font-normal">Premium</p>
              </div>
              <div className="flex py-4 border-b items-center">
                <p className="w-2/3 t-grey font-bold">Maximum Users</p>
                <p className="t-grey font-normal">300</p>
              </div>
              <div className="flex py-4">
                <p className="w-2/3 t-grey font-bold">Billing</p>
                <div className="t-grey font-normal">
                  <p>Next Billing: 4/24/23</p>
                  <p>Annual: $100 per year + tax</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="px-12 py-4">
          <div
            className={`flex items-center ${
              isLoading ? "justify-center" : ""
            }`}>
            <Button
              label="Cancel"
              className={`btn-cancel px-12 ${isLoading ? "hidden" : ""}`}
              onClick={() => showEditAccountContent()}
            />
            <Button
              isLoading={isLoading}
              disabled={!isFormSubmitable}
              label="Save"
              className="btn-primary px-12 ml-6 mr-6"
              onClick={() => submitOrgDetails()}
            />
            {user.role === "superAdmin" ? (
              <p
                className={`text-red-700 cursor-pointer ${
                  isLoading ? "hidden" : ""
                }`}
                onClick={() => showDeleteModal()}>
                Delete Account
              </p>
            ) : (
              <></>
            )}
            <ActionModal
              active={isDeleteOrgModalVisible}
              setActive={setIsDeleteOrgModalVisible}
              onSubmit={onSubmitDeleteOrg}
              header="You are deleting Organization :"
              userName={
                organizationDetails && organizationDetails?.name
                  ? organizationDetails.name
                  : ""
              }
              title="Are you sure you want to delete the record?"
              btnColor="red"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountDetail;
